import { observable } from "mobx";
import FuelType from "./fuelType";
import Enum from "../models/enum";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class FuelTypeResponse extends Enum {
  /**
   * Fuel type ID.
   */
  id!: string;

  @observable
  fuelType!: FuelType;

  /**
   * Localized fuel type name.
   */
  @observable
  name!: string;

  /**
   * Indicates whether fuel type is deleted.
   */
  @observable
  isDeleted!: boolean;
}

/**
 * Returns order of importance of each fuel type.
 * @param validFor
 */
export const fuelTypeOrder = (fuelType: FuelType): number => {
  switch (fuelType) {
    case FuelType.Other:
      return 1;
    case FuelType.Biomethane:
      return 2;
    case FuelType.NaturalGas:
      return 3;
    case FuelType.PhevWithLimitedCo2:
      return 4;
    default:
      return 5;
  }
};
